<template>
  <li class="dep__member-item member">
    <img :src="data.avatarUrl" alt class="member-avatar" @error="handleImgError"/>
    <div class="member-info dep__member-info" style="width: 80%">
      <div class="is-flex">
        <p class="dep__member-name member-name" style="margin: 0px;" v-if="data.name">{{data.name}}</p>
        <p class="dep__member-user member-user" v-if="data.name">{{data.user}}</p>
      </div>
      <p class="member-jobtitle" v-if="data.jobtitle">{{data.jobtitle}}</p>      
    </div>
    <button
      class="member-btn"
      @click="handleMemberClick"
      @mouseleave="active=false"
      :style="active?'cursor:unset':''"
      v-if="data.isAdded === true"
    >
    <i class="fas fa-trash" style="color: rgb(214 208 208);"></i>
      </button>
  </li>
</template>
<script>
import config from "../config";
import defaultImg from '../../public/img/unknown-icon.jpg'
export default {
  props: {
    data: {
      required: true
    },
    actionWindow: {
      default: false
    }
  },
  data() {
    return {
      active: false,
      conf:config,
      fallbackImg: defaultImg,
    };
  },
  emits: ["remove-visitor"],
  methods: {
    handleMemberClick() {
      this.$emit("remove-visitor", this.data._id);
    },
    handleImgError(event) {
      event.target.src = this.fallbackImg;
    }
  },
  mounted() {
  },
};
</script>
<style scoped>
.member-avatar{
  margin-right: 10px;
  object-fit: cover !important;
}

.member-btn{
  color: gray;
}

.dep__member-item{
  display: flex;
  align-items: center;
  justify-content: start !important;
}

.member{
  justify-content: start !important;
  gap: 10px;
}

.is-flex{
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  gap: 15px;
  }
  .member-name{
    width: 100%;
    max-width: 80ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>